export default function PHP_strripos() {
  return (
    <div>
      <h1>PHP_strripos</h1>
    </div>
  );
}
